// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"EquipmentItemDataInsert_tabPanel__Z_O5m"};